import React, { useState } from 'react';
import { Box } from '@mui/material';
import Step1CompanyInfo from './Step1companyinfo';
import Step2WhatsApp from './Step2WhatsApp';
import Step3BranchesUsers from './Step3BranchesUsers';
import SubmitOnboaringScreen from './SubmitOnboardingScreen';

const OnBoardingLayout = () => {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({});

  const handleNext = () => {
    setStep(step + 1);
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  return (
    <Box>
      {step === 1 && (
        <Step1CompanyInfo form={form} setForm={setForm} onNext={handleNext} />
      )}

      {step === 2 && (
        <Step2WhatsApp form={form} setForm={setForm} onBack={handleBack} onNext={handleNext} />
      )}

      {step === 3 && (
        <Step3BranchesUsers form={form} setForm={setForm} onBack={handleBack} onNext={handleNext} />
      )}

      {step === 4 && (
        <SubmitOnboaringScreen form={form} setForm={setForm} onBack={handleBack} onNext={handleNext} />
      )}
    </Box>
  );
};

export default OnBoardingLayout;
